import { Table, Button } from "antd";
import { EditOutlined } from "@ant-design/icons";

export default function ClientesIndex(props) {
  const { clientes, loading, setCliente, setVisible } = props;

  const columns = [
    {
      title: "Nombre",
      dataIndex: "NombreCliente",
      key: "NombreCliente",
      render: (text) => text || <span className="subtle-text">N/D</span>,
    },
    {
      title: "Apodo/Alias",
      dataIndex: "ApodoAlias",
      key: "ApodoAlias",
      render: (text) => text || <span className="subtle-text">N/D</span>,
    },
    {
      title: "Teléfono",
      dataIndex: "Telefono",
      key: "Telefono",
      render: (text) => text || <span className="subtle-text">N/D</span>,
    },
    {
      title: "Correo Electrónico",
      dataIndex: "CorreoElectronico",
      key: "CorreoElectronico",
      render: (text) => text || <span className="subtle-text">N/D</span>,
    },
    {
      title: "Acciones",
      dataIndex: "Acciones",
      key: "Acciones",
      render: (text, record) => (
        <Button
          type="primary"
          icon={<EditOutlined />}
          onClick={() => {
            setCliente(record);
            setVisible(true);
          }}
        />
      ),
    },
  ];

  return (
    <div>
      <Table
        columns={columns}
        dataSource={clientes}
        loading={loading}
        rowKey="ClienteID"
        pagination={{
          pageSize: 25,
          showSizeChanger: true,
          showLessItems: true,
        }}
        scroll={{
          x: "max-content",
        }}
      />
    </div>
  );
}
